import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import FeedbackReviewForm from "../../QRDetailPages/FeedbackReviewForm";

const FeedbackModal = ({ showFeedback, setShowFeedback, localQrData }) => {
  console.log("localQrDatalocalQrData", localQrData);
  return (
    <Modal
      show={showFeedback}
      onHide={() => setShowFeedback(false)}
      centered
      backdrop="static"
      className="feedbackModal fadeInUp"
    >
      <Modal.Header>
        <Modal.Title>Feedback</Modal.Title>
        <button className="close-btn" onClick={() => setShowFeedback(false)}>
          <IoClose size={24} color="#fff" />
        </button>
      </Modal.Header>
      <Modal.Body>
        {(localQrData?.questions?.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="feedback-container">
            <FeedbackReviewForm
              questions={localQrData?.questions}
              qrCodeObj={localQrData}
              setShowFeedback={setShowFeedback}
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FeedbackModal;
